/* eslint-disable i18next/no-literal-string */
import type { SubHeaderProps } from "@whatslly/types/UI-V2/SubHeaderType";
import classnames from "classnames";
import { observer } from "mobx-react-lite";
import React from "react";
import styles from "./sub-header.module.scss";
import copy from "copy-to-clipboard";
import { useToast } from "../Toaster/ToastContainer";
import { useTranslation } from "react-i18next";
import { BsFileEarmarkText } from "react-icons/bs";
import globalStyles from "../globalStyles";
export const SubHeader: React.FC<SubHeaderProps> = observer(({ children, copyOnClick, ...props }) => {
  const toaster = useToast();
  const { t } = useTranslation();
  return (
    <div
      className={classnames(
        styles.subHeaderContainer,
        globalStyles[`pi-${props.paddingInline ?? "default"}`],
        globalStyles[`mb-${props.marginBottom ?? "default"}`],
        globalStyles[`mt-${props.marginTop ?? "none"}`],
        globalStyles[`text-align-${props.textAlign ?? "center"}`]
      )}
    >
      <p
        className={classnames(
          globalStyles[`fw-${props.fontWeight ?? "default"}`],
          globalStyles[`fs-${props.fontSize ?? "small"}`],
          globalStyles[`color-${props.color ?? "main-primary"}`],
          { [styles.underLine]: props.underLine },
          styles.subHeader
        )}
      >
        {props.text ? props.text : children}
        {props.comment && <span className={styles.comment}>{props.comment}</span>}
      </p>
      {copyOnClick && (
        <div className={styles.copySubHeaderContainer}>
          <div
            className={styles.copySubHeaderAnimationContainer}
            onClick={() => {
              if (copyOnClick) {
                copy(props.text ?? "");
                toaster.triggerToast({
                  text: t("copied_to_clipboard"),
                });
              }
            }}
          >
            <BsFileEarmarkText />
          </div>
        </div>
      )}
    </div>
  );
});
